import React, { FC } from 'react';
import Modal from '@common/modal';
import { useStatusEnd } from '@repository/match';

import classnames from 'classnames/bind';
import styles from './modals.module.scss';
const cx = classnames.bind(styles);

interface ResumeEndModalProps {
  positionSn: number;
  visible: boolean;
  onClose: () => void;
  confirmAfter?: () => void;
}

const ResumeEndModal: FC<ResumeEndModalProps> = ({ positionSn, visible, onClose, confirmAfter }) => {
  //전형 종료로 이동(JF3공고만)
  const { mutate: fetchPositionEnd } = useStatusEnd(async () => {
    await confirmAfter?.();
    onClose();
  });

  const onClickDeleteCheck = () => {
    fetchPositionEnd(positionSn);
  };

  return (
    <Modal visible={visible}>
      <div className={cx('layer')}>
        <em className={cx('title')}>전형이 종료되었나요?</em>
        <p className={cx('desc')}>
          지원 현황에서 전형 종료로 포지션이 이동됩니다.
          <br />
          실제 전형이 종료되지 않았다면 전형 안내는 동일하게 받아보실 수 있습니다.
        </p>
        <div className={cx('btnArea')}>
          <button className={cx('btn', 'cancel')} onClick={onClose}>
            취소
          </button>
          <button className={cx('btn', 'check')} onClick={onClickDeleteCheck}>
            종료로 이동
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ResumeEndModal;
